/* eslint-disable import/no-cycle */
import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import ui from './modules/ui';
import vehicleInfo from './modules/vehicleInfo';
import documents from './modules/documents';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production' || process.env.MODE_VUE_DEVTOOLS === 'enabled';
// Fix: No Vuex store detected https://github.com/vuejs/vue-devtools/issues/405
Vue.config.devtools = debug;

const store = new Vuex.Store({
  state: {
    error: null
  },
  mutations: {
    ERROR_OCCURRED(state, error) {
      state.error = error;
    }
  },
  modules: {
    auth,
    ui,
    vehicleInfo,
    documents
  },
  strict: debug
});

export { store as default };
